import type { Permission } from '@/shared/api'
import type { AccessPair } from '@/shared/lib'
import type { PriceKind } from './types'

/**
 * `/v1/prices/*` — прайс-листы. Маршрут закрыт правом `price.view` (есть у каждого вошедшего).
 * Модификатора «от имени» у ресурса нет: `?client=` все ручки прайса отвергают `400`
 * (`acting.not-supported`), поэтому `onBehalf`/`accepts` в паре не заданы.
 */
export const PRICES_ACCESS: AccessPair = { own: 'price.view' }

/**
 * Доп.право на безналичный вид готового прайса — зависит от прайс-листа активного юрлица
 * (`docs/roles/01-model.md` §2): BYN открывает `price.br.view`, RUB — `price.bs.view`. Наличный
 * вид покрыт самим `price.view`, доп.права у него нет (`null`). Фронт прячет кнопку без права,
 * бэк дублирует проверку (`403` на закрытый вид).
 */
export const PRICE_KIND_PERMISSION: Record<PriceKind, Permission | null> = {
  cash: null,
  'cashless-byn': 'price.br.view',
  'cashless-rub': 'price.bs.view',
}

/** Переключатель ценовой колонки закрыт правом `price.column.switch` (`POST /v1/prices/column`). */
export const PRICE_COLUMN_SWITCH: Permission = 'price.column.switch'
